import md5 from "md5";
export function escapeHTML(string) {
    const entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
    };
    return string.replace(/[&<>"']/g, (key) => {
        return entityMap[key];
    });
}
/**
 * Splits the message by spaces then search for link patterns based on the regex
 * Then joins them together again, and if it finds the link pattern it wraps it
 * around <a> tags
 *
 * @private
 * @param  {String}  message Message
 * @return {string} message Message with anchors in case of links
 */
export function linkIfy(message) {
    // eslint-disable-next-line no-useless-escape
    const urlRegex = /(\b(https?:\/\/|www.)[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return message.replace(urlRegex, (url) => {
        const newUrl = url.indexOf("http") === -1 ? `http://${url}` : url;
        return `<a target="_blank" href="${newUrl}">${newUrl}</a>`;
    });
}
export const createIdFromMessage = (currentMessage) => {
    return md5(`${Date.now()}${JSON.stringify(currentMessage)}`);
};
